import { useI18n } from '../i18n';
import { OPERATOR } from '../lib/operator';

// Informational, not an overlay: never obstruct garden controls or mobile navigation.
export default function OperatorNotice() {
    const { locale } = useI18n();
    return <div className="mt-4 text-xs leading-relaxed text-brand-ink2" data-testid="operator-notice">
        <p>{locale === 'da'
            ? `${OPERATOR.brand} er et brand under ${OPERATOR.legalName}, virksomheden bag GrowDaily.`
            : `${OPERATOR.brand} is a brand of ${OPERATOR.legalName}, the business behind GrowDaily.`}</p>
        <a className="underline underline-offset-4 break-all" href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>
    </div>;
}
